import figures from 'figures'

export {figures as default}
